'use strict';
const assert = require('assert');
const Subscriptions = require('../subscriptions');
const chai = require('chai');
const sdkConfiguration = require('../../configurations/sdk-configuration');

const expect = chai.expect;
const credentials = {
  domain: 'csDesarrollo.onmicrosoft.com',
  clientId: 'f7d796b6-c2fe-4e70-b17f-e5d919695487',
  userName: 'app@csDesarrollo.onmicrosoft.com',
  password: 'Inn0vaci0n',
};
const fakeCustomerId = '123456789';
const fakeRequest = options => Promise.resolve(options);

/* eslint-disable no-undef, no-unused-vars */
describe('Subscriptions', () => {
  it('Creates a correct instance of the class', (done) => {
    const subscriptions = new Subscriptions(credentials, fakeRequest, sdkConfiguration, fakeCustomerId);
    expect(subscriptions).to.have.property('requestManager');
    expect(subscriptions.requestManager).to.have.property('requestConfigurationManager');
    expect(subscriptions.requestManager).to.have.property('authConfiguration');
    expect(subscriptions.requestManager.requestConfigurationManager).to.have.property('sdkConfiguration');
    expect(subscriptions.requestManager.requestConfigurationManager).to.have.property('credentials');
    expect(subscriptions.requestManager.requestConfigurationManager).to.have.property('request');
    expect(subscriptions).to.have.property('paramsManager');
    expect(subscriptions.paramsManager).to.have.property('pathParams');
    expect(subscriptions.paramsManager).to.have.property('bodyParams');
    expect(subscriptions.paramsManager).to.have.property('queryParams');
    assert(subscriptions.paramsManager.pathParams[0] === '123456789');
    done();
  });
  it('get, if subscriptionId is set return the subscription details', (done) => {
    const subscriptions = new Subscriptions(credentials, fakeRequest, sdkConfiguration, fakeCustomerId);
    subscriptions.byId('987').get().then((subscriptionDetails) => {
      assert(subscriptionDetails.method === 'GET');
      assert(subscriptionDetails.uri === 'https://api.partnercenter.microsoft.com/v1/customers/123456789/subscriptions/987');
      assert(subscriptionDetails.headers.Accept === 'application/json');
      assert(subscriptionDetails.headers['Content-Type'] === 'application/json');
      expect(subscriptionDetails.headers).to.have.property('MS-RequestId');
      expect(subscriptionDetails.headers).to.have.property('MS-CorrelationId');
    })
      .then(done, done);
  });
  it('get, if subscriptionId is not set return the subscription collection', (done) => {
    const subscriptions = new Subscriptions(credentials, fakeRequest, sdkConfiguration, fakeCustomerId);
    subscriptions.get().then((subscriptionDetails) => {
      assert(subscriptionDetails.method === 'GET');
      assert(subscriptionDetails.uri === 'https://api.partnercenter.microsoft.com/v1/customers/123456789/subscriptions');
      assert(subscriptionDetails.headers.Accept === 'application/json');
      assert(subscriptionDetails.headers['Content-Type'] === 'application/json');
      expect(subscriptionDetails.headers).to.have.property('MS-RequestId');
      expect(subscriptionDetails.headers).to.have.property('MS-CorrelationId');
    })
      .then(done, done);
  });
  it('getAddons, get the available addons for a subscription', (done) => {
    const subscriptions = new Subscriptions(credentials, fakeRequest, sdkConfiguration, fakeCustomerId);
    subscriptions.byId('989').getAddons().then((subscriptionDetails) => {
      assert(subscriptionDetails.method === 'GET');
      assert(subscriptionDetails.uri === 'https://api.partnercenter.microsoft.com/v1/customers/123456789/subscriptions/989/addons');
      assert(subscriptionDetails.headers.Accept === 'application/json');
      assert(subscriptionDetails.headers['Content-Type'] === 'application/json');
      expect(subscriptionDetails.headers).to.have.property('MS-RequestId');
      expect(subscriptionDetails.headers).to.have.property('MS-CorrelationId');
    })
      .then(done, done);
  });
  it('getAddons, if subscriptionId is not set, return an error', (done) => {
    const subscriptions = new Subscriptions(credentials, fakeRequest, sdkConfiguration, fakeCustomerId);
    try {
      subscriptions.getAddons();
    } catch (error) {
      assert(error.message === 'To use this function, first use the byId function, to set the subscriptionId');
      done();
    }
  });
  it('updateQuantity, if subscriptionId is not set, return an error', (done) => {
    const subscriptions = new Subscriptions(credentials, fakeRequest, sdkConfiguration, fakeCustomerId);
    try {
      subscriptions.updateQuantity();
    } catch (error) {
      assert(error.message === 'To use this function, first use the byId function, to set the subscriptionId');
      done();
    }
  });
  it('updateQuantity, updates the quantity of a subscription', (done) => {
    const subscriptions = new Subscriptions(credentials, fakeRequest, sdkConfiguration, fakeCustomerId);
    subscriptions.byId('989').updateQuantity(3).then((subscriptionDetails) => {
      assert(subscriptionDetails.method === 'PATCH');
      assert(subscriptionDetails.uri === 'https://api.partnercenter.microsoft.com/v1/customers/123456789/subscriptions/989');
      assert(subscriptionDetails.headers.Accept === 'application/json');
      assert(subscriptionDetails.headers['Content-Type'] === 'application/json');
      expect(subscriptionDetails.headers).to.have.property('MS-RequestId');
      expect(subscriptionDetails.headers).to.have.property('MS-CorrelationId');
      expect(subscriptionDetails).to.have.property('body');
      assert(subscriptionDetails.body.Id === '989');
      assert(subscriptionDetails.body.Quantity === 3);
    })
      .then(done, done);
  });
  it('suspend, suspend the subscription', (done) => {
    const subscriptions = new Subscriptions(credentials, fakeRequest, sdkConfiguration, fakeCustomerId);
    subscriptions.byId('989').suspend().then((subscriptionDetails) => {
      assert(subscriptionDetails.method === 'PATCH');
      assert(subscriptionDetails.uri === 'https://api.partnercenter.microsoft.com/v1/customers/123456789/subscriptions/989');
      assert(subscriptionDetails.headers.Accept === 'application/json');
      assert(subscriptionDetails.headers['Content-Type'] === 'application/json');
      expect(subscriptionDetails.headers).to.have.property('MS-RequestId');
      expect(subscriptionDetails.headers).to.have.property('MS-CorrelationId');
      expect(subscriptionDetails).to.have.property('body');
      assert(subscriptionDetails.body.Id === '989');
      assert(subscriptionDetails.body.Status === 'suspended');
    })
      .then(done, done);
  });
  it('suspend, if subscriptionId is not set, return an error', (done) => {
    const subscriptions = new Subscriptions(credentials, fakeRequest, sdkConfiguration, fakeCustomerId);
    try {
      subscriptions.suspend();
    } catch (error) {
      assert(error.message === 'To use this function, first use the byId function, to set the subscriptionId');
      done();
    }
  });
  it('activate, activate the subscription', (done) => {
    const subscriptions = new Subscriptions(credentials, fakeRequest, sdkConfiguration, fakeCustomerId);
    subscriptions.byId('989').activate().then((subscriptionDetails) => {
      assert(subscriptionDetails.method === 'PATCH');
      assert(subscriptionDetails.uri === 'https://api.partnercenter.microsoft.com/v1/customers/123456789/subscriptions/989');
      assert(subscriptionDetails.headers.Accept === 'application/json');
      assert(subscriptionDetails.headers['Content-Type'] === 'application/json');
      expect(subscriptionDetails.headers).to.have.property('MS-RequestId');
      expect(subscriptionDetails.headers).to.have.property('MS-CorrelationId');
      expect(subscriptionDetails).to.have.property('body');
      assert(subscriptionDetails.body.Id === '989');
      assert(subscriptionDetails.body.Status === 'active');
    })
      .then(done, done);
  });
  it('activate, if subscriptionId is not set, return an error', (done) => {
    const subscriptions = new Subscriptions(credentials, fakeRequest, sdkConfiguration, fakeCustomerId);
    try {
      subscriptions.activate();
    } catch (error) {
      assert(error.message === 'To use this function, first use the byId function, to set the subscriptionId');
      done();
    }
  });
  it('updatePartner, updates the mpn id of a subscription', (done) => {
    const subscriptions = new Subscriptions(credentials, fakeRequest, sdkConfiguration, fakeCustomerId);
    subscriptions.byId('989').updatePartner(999).then((subscriptionDetails) => {
      assert(subscriptionDetails.method === 'PATCH');
      assert(subscriptionDetails.uri === 'https://api.partnercenter.microsoft.com/v1/customers/123456789/subscriptions/989');
      assert(subscriptionDetails.headers.Accept === 'application/json');
      assert(subscriptionDetails.headers['Content-Type'] === 'application/json');
      expect(subscriptionDetails.headers).to.have.property('MS-RequestId');
      expect(subscriptionDetails.headers).to.have.property('MS-CorrelationId');
      expect(subscriptionDetails).to.have.property('body');
      assert(subscriptionDetails.body.Id === '989');
      assert(subscriptionDetails.body.PartnerId === 999);
    })
      .then(done, done);
  });
  it('updatePartner, if subscriptionId is not set, return an error', (done) => {
    const subscriptions = new Subscriptions(credentials, fakeRequest, sdkConfiguration, fakeCustomerId);
    try {
      subscriptions.updatePartner();
    } catch (error) {
      assert(error.message === 'To use this function, first use the byId function, to set the subscriptionId');
      done();
    }
  });
});
